import { LabFeatureFlags } from 'constants/lab'
import { useAppSelector } from 'hooks/reduxHooks'
import { isLabSiteTakeoverPayload } from 'lib/lab/dynamicPayload'
import { getCurrentSiteTakeover } from './useCurrentSiteTakeover'

/**
 * Hook-free variant so takeover theme surfaces share the same central eligibility gate.
 * This version is for use in SSR.
 */
export function getSiteTakeoverTheme(state: App.State): App.LabSiteTakeoverPayload | undefined {
  const enableSiteTakeover = state.system.features.labFlags[LabFeatureFlags.enableSiteTakeover]

  // TODO: Implement preview mode for site takeovers.
  if (!enableSiteTakeover?.enabled || !isLabSiteTakeoverPayload(enableSiteTakeover.value)) {
    return undefined
  }

  if (!getCurrentSiteTakeover(state)) {
    return undefined
  }

  return enableSiteTakeover.value
}

export function useSiteTakeoverTheme(): App.LabSiteTakeoverPayload | undefined {
  return useAppSelector(getSiteTakeoverTheme)
}
